import { Notify } from 'quasar';
import { t } from 'boot/i18n';

interface ImportantNotification {
  /** The human-readable explanation — the line the user must actually read. */
  message: string;
  /** Short context line rendered under the message (e.g. the failure's title). */
  caption?: string;
  icon?: string;
  color?: string;
}

/**
 * A notification the user has to dismiss themselves.
 *
 * Ordinary toasts fade from the bottom, which is fine for feedback the user can
 * miss. This one is for messages that *explain a dead end* — e.g. why an invite
 * link could not be used — so it sits in the middle of the screen, never times
 * out, and carries an explicit Close button.
 */
export function notifyImportant({
  message,
  caption,
  icon,
  color = 'negative',
}: ImportantNotification) {
  Notify.create({
    message,
    ...(caption ? { caption } : {}),
    ...(icon ? { icon } : {}),
    color,
    position: 'center',
    multiLine: true,
    timeout: 0, // stays until the user closes it
    closeBtn: t('CLOSE'),
  });
}
